import { useCallback } from 'react';
import { Dialog } from '@/components/ui/dialog';
import { CreateProductForm } from './CreateProductForm';
import type { ProductCategoryOptions } from '@components/Product/categories';

interface CreateProductDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /** Server-defined category vocabulary, scoped by format. */
  categoryOptions: ProductCategoryOptions;
}

export function CreateProductDialog({ open, onOpenChange, categoryOptions }: CreateProductDialogProps) {
  const handleClose = useCallback(() => onOpenChange(false), [onOpenChange]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      {open && <CreateProductForm onClose={handleClose} categoryOptions={categoryOptions} />}
    </Dialog>
  );
}
